// extracted by mini-css-extract-plugin
export default {"fiveRecipesContainer":"Gf5d3ed","fiveRecipesText":"G964e3f","leftArrow":"G85e70d"};